import cleanup from './cleanup-zh'
import placement from './placement-zh'

/** 检查所执行的图纸标准（计划 DS）。占位符与 drawing-en.ts 相同。 */
export default {
  drawingStandard: {
    title: '图纸标准：{{profile}}',
    intro: '检查严格按照此标准读取图纸。图层名称必须完全一致（不区分大小写）；不接受其他名称。',
    layersTitle: '图层',
    required: '必需',
    optional: '可选',
    roles: {
      site_boundary: '恰好一条闭合多段线或一个填充：场地边界。此图层上不得有其他内容。',
      landuse: '每个地块为一条独立的闭合多段线或一个填充，位于场地内。场地内的开放线条会导致检查不通过。',
      labels: '每个地块内的单行纯文本（TEXT），内容须与下列某个土地用途类别名称完全一致。',
      context: '相关时的辅助内容（等高线、排水、现有建筑）。不作检查。',
      ignored: '图纸所需的其他任何内容。读取后忽略。',
    },
    hintsOnly:
      '图层名称与标准名称相近时，检查报告会指出正确的图层，但这仅是提示；在重命名该图层之前，图纸仍不通过检查。',
    rulesTitle: '整张图纸的规则',
    rules: {
      modelSpace: '所有内容须绘制在模型空间中。不读取布局（图纸空间）。',
      units: '以米为单位，按所选坐标系的真实坐标绘制（{{crs}}）。',
      noBlocks: '必需图层上不得有块：请先分解。不读取块的内容。',
      closure: '场地边界必须闭合：缺口超过 {{tolerance}} m 即不通过。',
      area: '申报面积（公顷）与场地边界面积之差须在 {{pct}}% 以内。',
      format: '另存为 AutoCAD 2000 至 2018 的 DWG，或 DXF。',
    },
    classesTitle: '标注文本可用的土地用途类别名称',
    classesHint: '每个标注须完整写出其中一个名称。不区分大小写；其他文本不会为地块分类。',
    template: '下载符合标准的模板（DXF）',
    templateHint: '示例场地面积为 {{hectares}} 公顷，位于占位位置：请在真实坐标上绘制您自己的场地。',
    templateHintPlaced: '示例场地面积为 {{hectares}} 公顷，在您点击的位置打开：请在真实坐标上绘制您自己的场地。',
    pick: {
      open: '在我的场地位置打开模板',
      hint: '可选。在地图上点击您的场地，模板将按您选择的坐标系在该处打开。这只是起点：请在真实坐标上绘制您自己的场地。',
      unavailable: '此安装无法在此处将模板放到地图上，因此模板在占位位置打开。',
      map: '选择场地的地图',
      click: '请在地图上点击您的场地。',
      placed: '模板在 EPSG:{{srid}} 的 {{x}}, {{y}} 处打开。',
      failed: '无法按 EPSG:{{srid}} 读取该位置。请在此坐标系覆盖的范围内点击。',
      clear: '清除',
    },
  },
  findingHelp: {
    layerAbsent: '图纸中没有名为 {{layer}} 的图层。图层名称必须完全一致，不区分大小写。',
    layerUnusable: '图层 {{layer}} 存在，但其模型空间中没有可供检查使用的内容。',
    layerExact: '图层名称必须完全一致，不区分大小写。',
    nearMiss: '图层“{{near}}”看似 {{layer}}，但不会被读取：请将其重命名为 {{layer}}。',
    holds: {
      site_boundary: '{{layer}} 必须恰好包含一条闭合多段线或一个填充：场地边界。',
      landuse: '{{layer}} 必须将每个地块绘制为闭合多段线或填充。',
      labels: '{{layer}} 必须在每个地块内包含写明土地用途类别的纯文本。',
      context: '{{layer}} 可包含任何辅助内容。',
      ignored: '{{layer}} 可包含任何内容；不会被读取。',
    },
    unknownMore: '……另有 {{more}} 个未在此列出。',
    unknownExpected: '标准中的图层为：{{expected}}。',
    paperSpace: '只读取模型空间；布局（图纸空间）中的内容会被忽略。',
    oneLayer: '模型空间中的所有内容都在同一个图层“{{layer}}”上。请将场地边界、地块和标注分别放在各自的标准图层上。',
    noClosedShapes: '其线条未闭合。请将每个地块绘制为闭合多段线或填充；开放线条不计为地块。',
    plotsDropped:
      '其闭合图形均未在场地内形成地块：这些图形位于场地外、仅与场地边缘相接，或无法修复。请将每个地块绘制为场地内独立的闭合图形。',
    openLines: '请将 {{layer}} 上的每个地块绘制为闭合多段线或填充：将每条开放线条闭合为其地块的轮廓，或将其删除。',
    crsFitsOne: '您的图纸似乎采用 {{crs}}。请在 CAD 软件中核实，更改申报的坐标系后重新提交。',
    crsFitsSeveral:
      '按以下任一坐标系读取，您的图纸都位于管辖范围内：{{list}}。请在 CAD 软件中核实实际采用的坐标系，更改申报的坐标系后重新提交。',
    crsFitsNone:
      '所提供的坐标系都不能使场地位于管辖范围内。请确认图纸采用真实坐标，而不是 0,0 附近的局部坐标，然后重新提交。',
    crsCheck: '请在 CAD 软件中核实图纸采用的坐标系，并确认其位于真实坐标上。然后申报该坐标系并重新提交。',
    landedAt: '按 EPSG:{{srid}} 读取时，场地中心位于 {{x}}, {{y}}：经度 {{longitude}}，纬度 {{latitude}}。',
    unitsCheck: '图纸按米读取。请在 CAD 软件中检查其单位，如为其他单位请缩放为米，然后重新提交。',
    areaCompare: '请对照场地边界与表单上的面积，更正有误的一项后重新提交。',
    areaCentimetres:
      '场地面积约为申报面积的 10,000 倍。可能是其中一方的单位有误：表单要求填写公顷，以厘米绘制的图纸也会出现这种情况。请先核对申报的数值。只有该数值正确时，才将图纸缩放为米，然后重新提交。',
    areaMillimetres:
      '场地面积约为申报面积的 1,000,000 倍。可能是其中一方的单位有误：表单要求填写公顷，以毫米绘制的图纸也会出现这种情况。请先核对申报的数值。只有该数值正确时，才将图纸缩放为米，然后重新提交。',
    areaFeet:
      '场地面积约为申报面积的 10.8 倍。可能是其中一方的单位有误：表单要求填写公顷，以英尺绘制的图纸也会出现这种情况。请先核对申报的数值。只有该数值正确时，才将图纸缩放为米，然后重新提交。',
    areaSquareMetres:
      '申报的数值看起来是平方米：约为场地实测面积的 10,000 倍。表单要求填写公顷，请核对并以公顷填写（1 公顷为 10,000 平方米），然后重新提交。',
    datumCheck: '仅凭图纸无法区分这些网格。请询问图纸编制者所用的基准，并申报相应的坐标系。',
    noJurisdiction:
      '图纸中没有需要为此修正的内容。没有边界时，此处无法发现错误的坐标系，因此请在 CAD 软件中核实您申报的坐标系。',
  },
  nextStep: {
    title: '下一步：上传更正后的图纸',
    body: '图纸未通过检查。请修正检查报告中的每一项失败，然后将更正后的图纸作为此提交的下一版本上传。',
    upload: '上传更正后的图纸',
  },
  checkWording: { conversionLabel: '转换' },
  placement,
  cleanup,
} as const
